import ContactSection from "./ContactSection";
import ExpertiseSection from "./ExpertiseSection";
import HeroSection from "./HeroSection";
import ProjectSection from "./ProjectSection";

export default function AppBody(){
    return(
        <>
        <HeroSection/>
        <ExpertiseSection/>
        <ProjectSection/>
        <ContactSection/>
        </>

    )
}